import OverlayClass, * as OverlayModule from './../node_modules/ol/Overlay.js';

// Create a wrapper class
class Overlay extends OverlayClass{
    constructor(options) {
        super(options);
    }
}

// Copy all named exports as static methods
for (const key in OverlayModule) {
    if (key !== "default") {
        Overlay[key] = OverlayModule[key];
    }
}

export default Overlay;

// Re-export ALL named exports from OL
export * from './../node_modules/ol/Overlay.js';